export const rowsPerPageOptions = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export const faqSearchPlaceholder = "Search FAQ...";

export const faqExportFileName = "FAQ_Report";

export const faqStatusOptions = [
  { value: "", label: "All" },
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

export const emptySelectOption = {
  value: "",
  label: "Select",
};

export const questionOrderOptions = Array.from({ length: 50 }, (_, index) => ({
  value: index + 1,
  label: `${index + 1}`,
}));